import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PUBLIC_MARKET_URL } from "../projectMeta";

const MARKET_TITLE = "NUVELOR NFT Marketplace on NEAR";
const MARKET_OG_IMAGE = "https://nuvelor.gg/logo.jpg";

function setHeadValue({ selector, tagName, attribute, attributeValue, valueAttribute, value }) {
  let element = document.head.querySelector(selector);
  const created = !element;
  if (!element) {
    element = document.createElement(tagName);
    element.setAttribute(attribute, attributeValue);
    document.head.appendChild(element);
  }
  const previous = element.getAttribute(valueAttribute);
  element.setAttribute(valueAttribute, value);
  return () => {
    if (created) {
      element.remove();
    } else if (previous === null) {
      element.removeAttribute(valueAttribute);
    } else {
      element.setAttribute(valueAttribute, previous);
    }
  };
}

export default function MarketDocumentMetadata({ embedded = false }) {
  const { t, i18n } = useTranslation("market");

  useEffect(() => {
    const previousTitle = document.title;
    const previousLang = document.documentElement.lang;
    const description = t("shell.description");
    const restores = [
      setHeadValue({
        selector: 'link[rel="canonical"]',
        tagName: "link",
        attribute: "rel",
        attributeValue: "canonical",
        valueAttribute: "href",
        value: PUBLIC_MARKET_URL,
      }),
      setHeadValue({
        selector: 'meta[name="description"]',
        tagName: "meta",
        attribute: "name",
        attributeValue: "description",
        valueAttribute: "content",
        value: description,
      }),
      setHeadValue({
        selector: 'meta[name="robots"]',
        tagName: "meta",
        attribute: "name",
        attributeValue: "robots",
        valueAttribute: "content",
        value: embedded ? "noindex, follow" : "index, follow",
      }),
      ...[
        ["og:title", MARKET_TITLE],
        ["og:description", description],
        ["og:url", PUBLIC_MARKET_URL],
        ["og:image", MARKET_OG_IMAGE],
      ].map(([property, content]) =>
        setHeadValue({
          selector: `meta[property="${property}"]`,
          tagName: "meta",
          attribute: "property",
          attributeValue: property,
          valueAttribute: "content",
          value: content,
        })
      ),
    ];

    document.title = MARKET_TITLE;
    document.documentElement.lang = i18n.resolvedLanguage || i18n.language || "en";

    return () => {
      document.title = previousTitle;
      document.documentElement.lang = previousLang;
      restores.reverse().forEach((restore) => restore());
    };
  }, [embedded, i18n.language, i18n.resolvedLanguage, t]);

  return null;
}
